import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const CONF = { l: "Rendah", n: "Sedang", h: "Tinggi", low: "Rendah", nominal: "Sedang", high: "Tinggi" };
const SAT = { N: "Suomi NPP", N20: "NOAA-20", N21: "NOAA-21" };
const MAX_POINTS = 1500;

const radiusFor = (frp) => Math.min(11, 3.5 + Math.sqrt(Math.max(frp, 0)) * 0.7);
const colorFor = (frp) => (frp >= 40 ? "#ef4444" : frp >= 12 ? "#f97316" : "#fb923c");

const popupHtml = (p) => {
  const t = String(p.acq_time || "").padStart(4, "0");
  const time = p.acq_time ? `${t.slice(0, 2)}:${t.slice(2)} UTC` : "-";
  return `<div class="fire-popup" data-testid="fire-popup">
    <div class="fire-popup-title">Titik Api</div>
    <div><span>Terdeteksi</span><b>${p.acq_date} ${time}</b></div>
    <div><span>Kekuatan (FRP)</span><b>${p.frp} MW</b></div>
    <div><span>Satelit</span><b>${SAT[p.satellite] || p.satellite || "VIIRS"}</b></div>
    <div><span>Kepercayaan</span><b>${CONF[p.confidence] || p.confidence || "-"}</b></div>
    <div><span>Koordinat</span><b>${p.lat.toFixed(3)}, ${p.lon.toFixed(3)}</b></div>
  </div>`;
};

export const FireLayer = ({ fires, enabled }) => {
  const map = useMap();
  const group = useRef(null);
  const renderer = useRef(null);

  useEffect(() => {
    renderer.current = L.canvas({ padding: 0.3 });
    group.current = L.layerGroup().addTo(map);
    return () => {
      group.current.remove();
    };
  }, [map]);

  useEffect(() => {
    const g = group.current;
    g.clearLayers();
    if (!enabled || !fires) return;
    fires.points.slice(0, MAX_POINTS).forEach((p) => {
      const color = colorFor(p.frp);
      L.circleMarker([p.lat, p.lon], {
        renderer: renderer.current,
        radius: radiusFor(p.frp),
        color,
        weight: 1.5,
        opacity: 0.9,
        fillColor: color,
        fillOpacity: 0.45,
        className: "fire-marker",
      })
        .bindPopup(popupHtml(p), { className: "aethera-popup", closeButton: true, maxWidth: 240 })
        .addTo(g);
    });
  }, [fires, enabled]);

  return null;
};
